import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { en_GB, provideNzI18n } from 'ng-zorro-antd/i18n';
import { provideNzIcons } from 'ng-zorro-antd/icon';
import { NzModalModule } from 'ng-zorro-antd/modal';

const enGbLocale = {
  ...en_GB,
  DatePicker: {
    ...en_GB.DatePicker,
    lang: {
      ...en_GB.DatePicker.lang,
      rangeQuarterPlaceholder: ['Start quarter', 'End quarter'],
    },
  },
};
import {
  SaveOutline, LoginOutline, LogoutOutline, ShareAltOutline,
  CheckOutline, WarningOutline, CalculatorOutline, DeleteOutline,
  CopyOutline, InfoCircleOutline, EditOutline, PlusCircleOutline,
  PlusOutline, EyeOutline, EyeInvisibleOutline, DownOutline,
  LoadingOutline, UserOutline, ArrowLeftOutline, FileTextOutline,
  PrinterOutline, MailOutline, SendOutline, CloseOutline,
  // Additional icons used across the app
  TeamOutline, ScanOutline, CloseCircleOutline, PaperClipOutline,
  CameraOutline, SearchOutline, LinkOutline, PercentageOutline,
  CheckCircleOutline, ClockCircleOutline, SwapOutline, DownloadOutline,
  UploadOutline, CloseCircleFill,
  DashboardOutline, ArrowRightOutline,
  AuditOutline, BankOutline, BulbOutline, CloudUploadOutline,
  DisconnectOutline, FileOutline, FileAddOutline, FileDoneOutline,
  HomeOutline, QrcodeOutline, SyncOutline, ThunderboltOutline, ReloadOutline
} from '@ant-design/icons-angular/icons';

import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideAnimationsAsync(),
    provideNzI18n(enGbLocale),
    importProvidersFrom(NzModalModule),
    provideNzIcons([
      SaveOutline, LoginOutline, LogoutOutline, ShareAltOutline,
      CheckOutline, WarningOutline, CalculatorOutline, DeleteOutline,
      CopyOutline, InfoCircleOutline, EditOutline, PlusCircleOutline,
      PlusOutline, EyeOutline, EyeInvisibleOutline, DownOutline,
      LoadingOutline, UserOutline, ArrowLeftOutline, FileTextOutline,
      PrinterOutline, MailOutline, SendOutline, CloseOutline,
      TeamOutline, ScanOutline, CloseCircleOutline, PaperClipOutline,
      CameraOutline, SearchOutline, LinkOutline, PercentageOutline,
      CheckCircleOutline, ClockCircleOutline, SwapOutline, DownloadOutline,
      UploadOutline, CloseCircleFill,
      DashboardOutline, ArrowRightOutline,
      AuditOutline, BankOutline, BulbOutline, CloudUploadOutline,
      DisconnectOutline, FileOutline, FileAddOutline, FileDoneOutline,
      HomeOutline, QrcodeOutline, SyncOutline, ThunderboltOutline, ReloadOutline
    ]),
  ],
};
